<template>
  <sidebarMob/>
  
</template>

<script>
  export default {
    components: {},
  }
</script>

<style lang="scss">
.container-fluid {
    max-width: 100% !important;
}
.no-padding{
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue